import { IconSource } from '@prenuvo/halo';
import { QuestionCircle } from '@prenuvo/halo-icon';

import { CARE_SERVICE_ORGANS_PARENT_KEY } from '@/api';
import { REPORT_LINK_KEY, ReportLink, ReportLinkKey } from '@/shared/model';
import { isNotEmpty, parseOrganTitle } from '@/shared/util';

export const getOrganIconFromLinks = (title: string, links: ReportLink[]) => {
  const link = links.find(
    ({ key, sub }) =>
      sub?.some(
        (subLink) =>
          subLink.key === title || subLink.sub?.some((subOfSubLink) => subOfSubLink.key === title),
      ) || key === title,
  );

  if (link?.key === CARE_SERVICE_ORGANS_PARENT_KEY.OTHER_ORGANS) {
    const subLink = link.sub?.find(
      ({ key, sub }) => sub?.some((subOfSubLink) => subOfSubLink.key === title) || key === title,
    );

    return (subLink?.icon ?? QuestionCircle) as IconSource;
  }

  return (link?.icon ?? QuestionCircle) as IconSource;
};

export const getOrganTitleFromLinks = (organ: string, links: ReportLink[]) => {
  const link = links.find(({ key }) => key === organ);

  if (!link) {
    const subLink = links.find((item) => item.sub?.some((sub) => sub.key === organ));

    if (subLink) {
      return subLink.sub?.find(({ key }) => key === organ)?.title ?? parseOrganTitle(organ);
    }

    return parseOrganTitle(organ);
  }

  return link.title;
};

export const isOrganDisabled = (organ: string, links: ReportLink[]) => {
  const link = links.find(({ key }) => key === organ);

  if (!link) {
    const subLink = links.find((item) =>
      item.sub?.some(
        (sub) => sub.key === organ || sub.sub?.some((subOfSub) => subOfSub.key === organ),
      ),
    );

    return subLink ? subLink.disabled : false;
  }

  return link.disabled;
};

export const flattenLinks = (links: ReportLink[] = []): ReportLink[] => {
  const IGNORE_KEYS: ReportLinkKey[] = [REPORT_LINK_KEY.NECK, REPORT_LINK_KEY.OTHER_ORGANS];

  return links.flatMap((item) => {
    if (IGNORE_KEYS.includes(item.key)) {
      if (isNotEmpty(item.sub)) {
        return flattenLinks(item.sub);
      }

      return [];
    }

    return [item, ...(isNotEmpty(item.sub) ? flattenLinks(item.sub) : [])];
  });
};
